<template>
  <Modal ref="modalRef" info>
    <template #title>Living people to include</template>
    <template #okText>Done</template>

    <div class="alert alert-primary">
      <ShieldIcon size="1.3x" class="privacy"/> You should only include people you know personally.
    </div>
    <LivingPeopleEditor :session-id="sessionId"/>

    <template #secondaryContent>
      <button v-if="showSelectDefaultRef" type="button" class="btn btn-outline-primary select-default" @click="selectDefault">
        Select default
      </button>
    </template>
  </Modal>
</template>

<style lang="scss" scoped>
.alert {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;

  .privacy {
    margin-right: 0.25rem;
  }
}

.select-default {
  min-width: 100px;
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { ShieldIcon } from '@zhuowenli/vue-feather-icons'
import Modal from '@webapp/util/Modal.vue'
import { useSyncSessionStore } from './SyncSessionStore'
import LivingPeopleEditor from './LivingPeopleEditor.vue'

const props = defineProps<{
  sessionId: string
}>()

defineExpose({
  open,
})

const syncSessionStore = useSyncSessionStore()

const modalRef = ref<InstanceType<typeof Modal>>()

const showSelectDefaultRef = computed(() => !syncSessionStore.getSession(props.sessionId)?.lastSyncId)

function open() {
  modalRef.value?.open()
}

function selectDefault() {
  syncSessionStore.selectDefaultLivingWindowPersons(props.sessionId)
}
</script>
